module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"deleteWarning":"Вы уверены, что хотите удалить вопрос?","yes":"Да","no":"Нет"}}')
  delete Component.options._Ctor
}
